import { render, staticRenderFns } from "./ManageSproutVideo.vue?vue&type=template&id=3c17344a&"
import script from "./ManageSproutVideo.vue?vue&type=script&lang=js&"
export * from "./ManageSproutVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports